/* NP · spodní lišta — chování
 *
 * Tři věci: otevřít/zavřít panel kategorií, držet počet v košíku
 * aktuální a otevřít Shopify Inbox.
 *
 * Inbox nemá veřejné API, kterým by se dal otevřít; jeho vlastní
 * bublina je v iframu třetí strany. Na mobilu tu bublinu schováváme
 * (CSS) a naše tlačítko na ni klepne za uživatele. Když se iframe
 * nenajde, tlačítko se tiše skryje — lepší než mrtvý ovládací prvek.
 */
(function () {
  var bar = document.querySelector('[data-np-bbar]');
  if (!bar) return;

  /* --- panel kategorií --- */
  var sheet = document.querySelector('[data-np-bbar-sheet]');
  var shopBtn = bar.querySelector('[data-np-bbar-shop]');
  function openSheet(open) {
    if (!sheet) return;
    sheet.hidden = !open;
    sheet.classList.toggle('is-open', open);
    // Fotky v panelu jsou lazy, aby je nikdo nestahoval zbytečně. Dokud
    // je panel skrytý, prohlížeč je ale nepovažuje za blížící se k výřezu
    // a zůstaly by šedé i po otevření — tady je proto pustíme ručně.
    if (open) {
      var imgs = sheet.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }
    if (shopBtn) shopBtn.setAttribute('aria-expanded', String(open));
  }
  if (shopBtn) shopBtn.addEventListener('click', function () { openSheet(sheet.hidden); });
  if (sheet) {
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.hasAttribute('data-np-bbar-sheet-close')) openSheet(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openSheet(false); });
  }

  /* --- počet v košíku --- */
  var count = bar.querySelector('[data-np-bbar-count]');
  function setCount(n) {
    if (!count) return;
    count.textContent = n;
    count.classList.toggle('np-bbar__count--empty', !n);
  }
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  // Impulse pošle tuhle událost po každé změně košíku.
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:build', refresh);
  document.addEventListener('ajaxProduct:added', refresh);

  /* --- nákup na PDP --- */
  var atc = bar.querySelector('[data-np-bbar-atc]');
  var barPrice = bar.querySelector('[data-np-bbar-price]');
  if (atc) {
    atc.addEventListener('click', function () {
      var real = document.querySelector('.product-single__form [name="add"], form[action*="/cart/add"] [name="add"]');
      if (real) { real.click(); return; }
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) form.submit();
    });
    // Cena v liště sleduje cenu na stránce (změna varianty ji přepíše).
    // :not(--compare) schválně: .product__price matchuje i přeškrtnutou
    // původní cenu a lišta pak hlásila cenu před slevou.
    var pagePrice = document.querySelector('.product__price:not(.product__price--compare):not(.product__price--sale-compare), [data-product-price]:not([data-compare-price])');
    if (pagePrice && barPrice) {
      var sync = function () {
        var t = (pagePrice.textContent || '').trim();
        if (t) barPrice.textContent = t.split('\n')[0].trim();
      };
      sync();
      new MutationObserver(sync).observe(pagePrice, { childList: true, subtree: true, characterData: true });
    }
  }

  /* --- chat --- */
  var chatBtn = bar.querySelector('[data-np-bbar-chat]');
  function findChat() {
    // <shopify-chat> je vlastní element, ne id — selektor #shopify-chat
    // nikdy nic nenašel a tlačítko se po osmi sekundách samo skrylo.
    return document.querySelector('shopify-chat, #ShopifyChat, iframe[name="chat-button-iframe"], iframe[title*="chat" i]');
  }
  if (chatBtn) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var el = findChat();
      if (el) {
        clearInterval(t);
        chatBtn.addEventListener('click', function () {
          document.documentElement.classList.add('np-chat-visible');
          // Bublina Inboxu bydlí v shadow DOM; když je root otevřený,
          // klepneme za uživatele, jinak mu ji aspoň odkryjeme.
          var inner = null;
          try { inner = el.shadowRoot && el.shadowRoot.querySelector('button, [role="button"]'); } catch (e) {}
          if (inner) { try { inner.click(); } catch (e) {} }
        });
      } else if (tries > 40) {           // ~8 s: Inbox na stránce není
        clearInterval(t);
        chatBtn.hidden = true;
      }
    }, 200);
  }
})();

/* NP · mapa na vyžádání
 *
 * Google Maps iframe na homepage byl největší obsahový blok na mobilu
 * (838 px) a tahal s sebou cizí skript ještě předtím, než o mapu někdo
 * stál. Teď se vykreslí adresa, odkaz „Get directions" a tlačítko;
 * iframe se vloží teprve po klepnutí.
 */
(function () {
  var wrap = document.querySelector('[data-np-map]');
  if (!wrap) return;
  var btn = wrap.querySelector('[data-np-map-load]');
  var frame = wrap.querySelector('[data-np-map-frame]');
  var ph = wrap.querySelector('[data-np-map-ph]');
  if (!btn || !frame) return;

  btn.addEventListener('click', function () {
    if (frame.querySelector('iframe')) return;
    var f = document.createElement('iframe');
    f.src = frame.getAttribute('data-src');
    f.width = '100%';
    f.height = '420';
    f.loading = 'lazy';
    f.referrerPolicy = 'no-referrer-when-downgrade';
    f.style.border = '0';
    f.title = 'Night Pearl USA, Sarasota';
    frame.appendChild(f);
    if (ph) ph.classList.add('np-map__placeholder--loaded');
    btn.hidden = true;
  });
})();

/* NP · lišta nad Shopify preview barem
 *
 * Coobee lištu na telefonu neviděl: je přihlášený do adminu a Shopify
 * mu dole vykresluje vlastní preview bar v iframe, který ji překryl.
 * Zákazník žádný preview bar nemá, takže se pro něj nic nemění —
 * proměnná zůstane nulová a všechna pravidla počítají s 0 px.
 *
 * Bar se vkládá až po načtení stránky a umí změnit výšku, proto
 * MutationObserver a resize, ne jedno měření na startu.
 */
(function () {
  var SEL = '#preview-bar-iframe, iframe[id*="preview-bar"], iframe[name*="preview-bar"]';
  var root = document.documentElement;

  function apply() {
    var bar = document.querySelector(SEL);
    var h = 0;
    if (bar) {
      var box = bar.getBoundingClientRect();
      // Skrytý nebo odrolovaný bar nemá co odsazovat.
      if (box.height > 0 && getComputedStyle(bar).display !== 'none') {
        h = Math.round(box.height);
      }
    }
    root.style.setProperty('--np-bbar-offset', h + 'px');
  }

  apply();
  window.addEventListener('resize', apply);
  window.addEventListener('load', apply);
  new MutationObserver(apply).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden']
  });
})();

/* NP · úvodní text kolekce na dva řádky
 *
 * Na /collections/all zabíral úvodní odstavec na telefonu devět řádků
 * a odsouval kategorie pod první obrazovku. Zkrátí se na dva řádky
 * a rozbalí tlačítkem; desktop zůstává celý.
 *
 * Dělá to skript, a ne jen CSS, protože rozbalení potřebuje ovladač —
 * a sekce rich-text je theme.liquid, do kterého se kvůli tomu nelezlo.
 */
(function () {
  var MQ = window.matchMedia('(max-width: 768px)');
  var done = false;

  function build() {
    if (done || !MQ.matches) return;
    var host = document.querySelector('.template-collection [id$="__intro"] .rte');
    if (!host) return;
    done = true;

    host.classList.add('np-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'np-clamp__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    host.parentNode.insertBefore(btn, host.nextSibling);

    btn.addEventListener('click', function () {
      var open = host.classList.toggle('np-clamp--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  }

  build();
  MQ.addEventListener ? MQ.addEventListener('change', build) : MQ.addListener(build);
  document.addEventListener('DOMContentLoaded', build);
})();
